import React from 'react';
import css from './TagChip.module.scss';

export type TagChipSize = 'sm' | 'md' | 'lg';

type TagChipProps = {
  text: string | null;
  color: string | null;
  iconUrl: string | null;
  size?: TagChipSize;
  className?: string;
  title?: string;
};

const ICON_SIZE: Record<TagChipSize, number> = {
  sm: 10,
  md: 14,
  lg: 18,
};

const SIZE_CLASS: Record<TagChipSize, string> = {
  sm: css.chipSm,
  md: css.chipMd,
  lg: css.chipLg,
};

function getContrastColor(hex: string): string {
  const c = hex.replace('#', '');
  const r = parseInt(c.substring(0, 2), 16);
  const g = parseInt(c.substring(2, 4), 16);
  const b = parseInt(c.substring(4, 6), 16);
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.55 ? '#000' : '#fff';
}

export function TagChip({
  text, color, iconUrl, size = 'md', className, title,
}: TagChipProps) {
  if (!text && !iconUrl) {
    return <span className="text-muted small">—</span>;
  }

  const bg = color ?? '#808080';
  const iconSize = ICON_SIZE[size];
  const chipClass = [css.chip, SIZE_CLASS[size], className ?? ''].filter(Boolean).join(' ');

  return (
    <span
      className={chipClass}
      style={{ backgroundColor: bg, color: getContrastColor(bg) }}
      title={title}
      data-testid="tag-chip"
    >
      {iconUrl && (
        <img
          src={iconUrl}
          alt=""
          className={css.chipIcon}
          style={{ width: iconSize, height: iconSize }}
        />
      )}
      {text && <span className={css.chipText}>{text}</span>}
    </span>
  );
}
